var exports = {
  "kL": "ChannelStickersArea.module__container___REp2dG",
  "gI": "ChannelStickersArea.module__standalone___REp2dG",
  "Qs": "ChannelStickersArea.module__content___REp2dG",
  "UV": "ChannelStickersArea.module__stickerPreview___REp2dG",
  "HF": "ChannelStickersArea.module__stickerImage___REp2dG",
  "od": "ChannelStickersArea.module__stickerInfo___REp2dG",
  "Zl": "ChannelStickersArea.module__stickerName___REp2dG",
  "Gl": "ChannelStickersArea.module__stickerDescription___REp2dG",
  "DT": "ChannelStickersArea.module__removeButton___REp2dG",
  "Kk": "ChannelStickersArea.module__icon___REp2dG",
};

module.exports = exports;
